// @ts-nocheck
import React from 'react';
import { Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import MainLayout from '@/layouts/MainLayout';
import ErrorLayout from '@/layouts/ErrorLayout';
import Error404 from '@/components/errors/Error404';
import Error500 from '@/components/errors/Error500';

import {
  Dashboard,
  Report,
  Analysis,
  Settings,
  ContentTools,
  KeywordResearch,
  Crawl,
  KeywordTracker,
  TrackerAi,
  Serp,
  Purchase,
  Domain,
  Membership,
  Auth,
  BacklinkNew,
  Support,
  Wallet,
  Mcp,
  Indexer
} from '@/app/';
import {
  GapPageRedirect,
  ReferralPageRedirect
} from '@/app/BacklinkNew/utils/backlinkRoutes';
import useDomain from '@/hooks/useDomain';
import { CHANGELOG_DOCS_URL } from '@/config';
import { Container } from 'react-bootstrap';
import TestPage from './TestPage';

const RedirectLegacyAiDetails = () => {
  const { id, domain_slug, domain } = useParams();
  return (
    <Navigate
      to={`/content-tools/ai-analysis/overview/${domain_slug}/${domain}/${id}`}
      replace
    />
  );
};

const RedirectTrackerAi = ({ section }: { section: string }) => {
  const { domain_slug, domain } = useDomain();
  const { search } = useLocation();
  if (!domain_slug || !domain) return null;
  return (
    <Navigate
      to={`/tracker-ai/${section}/${domain_slug}/${domain}${search}`}
      replace
    />
  );
};

const RedirectMcpToChat = () => {
  const location = useLocation();
  return (
    <Navigate
      to={{
        pathname: location.pathname.replace(/^\/mcp(?=\/|$)/, '/chat'),
        search: location.search,
        hash: location.hash
      }}
      replace
      state={location.state}
    />
  );
};

const RedirectToChangelogDocs = () => {
  React.useEffect(() => {
    window.location.replace(CHANGELOG_DOCS_URL);
  }, []);
  return null;
};

// import ReloadPrompt from '@/ReloadPrompt';
const FalconRoutes = () => {
  const { domain_slug, domain } = useDomain();
  return (
    <React.Suspense fallback={() => <>loading layout</>}>
      {/* <ReloadPrompt /> */}
      <Routes>
        {/* INVOICE ROUTER */}
        <Route path="/orders/invoice/:invoice" element={<Purchase.Invoice />} />
        {/* FACTORS */}
        <Route path="/orders/factor/:order_id" element={<Purchase.Invoice />} />
        <Route element={<ErrorLayout />}>
          <Route
            path="errors/404"
            element={
              <>
                <Helmet>
                  <title>خطای 404</title>
                </Helmet>
                <Error404 />
              </>
            }
          />
          <Route
            path="errors/500"
            element={
              <>
                <Helmet>
                  <title>خطای 500</title>
                </Helmet>
                <Error500 />
              </>
            }
          />
        </Route>

        {/* MEMBERSHIP */}
        <Route path="/membership-steps" element={<Membership.Layout />}>
          <Route
            path=""
            element={
              <>
                <Helmet>
                  <title>انتخاب طرح</title>
                </Helmet>
                <Purchase.Upgrade isMemberStep />
              </>
            }
          />
          <Route
            path="payment"
            element={
              <>
                <Helmet>
                  <title>پرداخت</title>
                </Helmet>
                <Purchase.Payment isMemberStep />
              </>
            }
          />
          <Route
            path="domains"
            element={
              <>
                <Helmet>
                  <title>افزودن دامنه</title>
                </Helmet>
                <Membership.AddDomains />
              </>
            }
          />
          <Route
            path="keywords/:domain_slug"
            element={
              <>
                <Helmet>
                  <title>افزودن کلمات</title>
                </Helmet>
                <Membership.AddKeywords />
              </>
            }
          />

        </Route>
        <Route
          path="/login"
          element={
            <>
              <Helmet>
                <title>ورود</title>
              </Helmet>
              <Auth.Login />
            </>
          }
        />
        <Route
          path="/callback"
          element={
            <>
              <Helmet>
                <title>ورود</title>
              </Helmet>
              <Auth.CasdoorCallback />
            </>
          }
        />
        <Route
          path="/mcp/connect/callback"
          element={
            <>
              <Helmet>
                <title>دستیار AI — اتصال MCP</title>
              </Helmet>
              <Mcp.ConnectCallback />
            </>
          }
        />
        <Route
          path="/test"
          element={
            <>
              <Helmet>
                <title>ورود</title>
              </Helmet>
              <TestPage />
            </>
          }
        />
        <Route
          path="/reporting/tracker/:id"
          element={
            <>
              <Helmet>
                <title>گزارش گیری</title>
              </Helmet>
              <Report.Details />
            </>
          }
        />
        <Route
          path="/reporting/page_speed/:slug"
          element={
            <>
              <Helmet>
                <title>گزارش سرعت سایت</title>
              </Helmet>
              <Analysis.PublicSpeed />
            </>
          }
        />
        <Route path="change-log" element={<RedirectToChangelogDocs />} />
        <Route element={<MainLayout />}>
          <Route element={<Auth.ProtectedRoute />}>
            <Route path="/reporting" element={<Report.Overview />}>
              <Route
                path="tracker/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>گزارش گیری</title>
                    </Helmet>
                    <Report.Overview />
                  </>
                }
              />
            </Route>
            <Route
              path="/reporting/page_speed/:domain_slug/:domain"
              element={
                <>
                  <Helmet>
                    <title>گزارش سرعت سایت</title>
                  </Helmet>
                  <Analysis.PageSpeedReport />
                </>
              }
            />
            <Route
              path="/"
              element={
                <>
                  <Helmet>
                    <title>پیشخوان جدید</title>
                  </Helmet>
                  <Dashboard />
                </>
              }
            />
            {/* BACKLINK NEW — product API tabs */}
            <Route path="/backlink" element={<BacklinkNew.Layout />}>
              <Route path="" element={<Navigate to="overview" replace />} />
              <Route path="overview" element={<BacklinkNew.Overview />} />
              <Route
                path="overview/:domain_slug/:domain"
                element={<BacklinkNew.Overview />}
              />
              <Route path="backlinks" element={<BacklinkNew.Backlinks />} />
              <Route
                path="backlinks/:domain_slug/:domain"
                element={<BacklinkNew.Backlinks />}
              />
              <Route path="referral-page" element={<ReferralPageRedirect />} />
              <Route
                path="referral-page/:domain_slug/:domain"
                element={<ReferralPageRedirect />}
              />
              <Route
                path="referral-domain"
                element={<BacklinkNew.ReferralDomain />}
              />
              <Route
                path="referral-domain/:domain_slug/:domain"
                element={<BacklinkNew.ReferralDomain />}
              />
              <Route path="referring-ip" element={<BacklinkNew.ReferringIpPage />} />
              <Route
                path="referring-ip/:domain_slug/:domain"
                element={<BacklinkNew.ReferringIpPage />}
              />
              <Route path="anchor-text" element={<BacklinkNew.AnchorTextPage />} />
              <Route
                path="anchor-text/:domain_slug/:domain"
                element={<BacklinkNew.AnchorTextPage />}
              />
              <Route path="spam-domain" element={<BacklinkNew.SpamDomain />} />
              <Route
                path="spam-domain/:domain_slug/:domain"
                element={<BacklinkNew.SpamDomain />}
              />
              <Route path="internal-page" element={<BacklinkNew.InternalPage />} />
              <Route
                path="internal-page/:domain_slug/:domain"
                element={<BacklinkNew.InternalPage />}
              />
              <Route path="gap" element={<GapPageRedirect />} />
              <Route
                path="gap/:domain_slug/:domain"
                element={<GapPageRedirect />}
              />
            </Route>

            <Route path="/indexer" element={<Indexer.Layout />}>
              <Route
                path="onboarding/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>راه‌اندازی ایندکسر</title>
                    </Helmet>
                    <Indexer.Onboarding />
                  </>
                }
              />
              <Route
                path="overview/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>ایندکسر — نمای کلی</title>
                    </Helmet>
                    <Indexer.Overview />
                  </>
                }
              />
              <Route
                path="index/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>ایندکسر — درخواست ایندکس</title>
                    </Helmet>
                    <Indexer.Index />
                  </>
                }
              />
              <Route
                path="url-inspection/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>ایندکسر — وضعیت ایندکس</title>
                    </Helmet>
                    <Indexer.Inspect />
                  </>
                }
              />
              <Route
                path="urls/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>ایندکسر — لیست آدرس‌ها</title>
                    </Helmet>
                    <Indexer.Urls />
                  </>
                }
              />
              <Route
                path="changes/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>ایندکسر — تغییرات</title>
                    </Helmet>
                    <Indexer.Changes />
                  </>
                }
              />
              <Route
                path="settings/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>ایندکسر — تنظیمات</title>
                    </Helmet>
                    <Indexer.Settings />
                  </>
                }
              />
              <Route
                path="*"
                element={
                  <Navigate
                    to={`/indexer/overview/${domain_slug}/${domain}`}
                    replace
                  />
                }
              />
            </Route>
            {/* ANALYSIS ROUTER */}
            {/* ANALYSIS ROUTER */}
            <Route path="/analysis" element={<Analysis.Layout />}>
              <Route
                path="history/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>تاریخچه واکاوی</title>
                    </Helmet>
                    <Analysis.History />
                  </>
                }
              />
              <Route
                path="overview/:slug/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>نمای کلی واکاوی</title>
                    </Helmet>
                    <Analysis.Overview />
                  </>
                }
              />
              <Route
                path="speed/:slug/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>سرعت واکاوی</title>
                    </Helmet>
                    <Analysis.Speed />
                  </>
                }
              />
              <Route
                path="crux/:slug/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>گزارش CrUX</title>
                    </Helmet>
                    <Analysis.Crux />
                  </>
                }
              />
              <Route
                path="comparison/:slug/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>مقایسه واکاوی</title>
                    </Helmet>
                    <Analysis.Comparison />
                  </>
                }
              />
              <Route
                path="internal-seo/:slug/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>سئوی داخلی واکاوی</title>
                    </Helmet>
                    <Analysis.InternalSeo />
                  </>
                }
              />
            </Route>
            {/* CRAWL ROUTER */}
            <Route path="/crawl" element={<Crawl.Layout />}>
              <Route
                path="history/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>خزش جدید</title>
                    </Helmet>
                    <Crawl.History />
                  </>
                }
              />
              <Route
                path="overview/:slug/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title> نمای کلی خزش</title>
                    </Helmet>
                    <Crawl.Overview />
                  </>
                }
              />
              <Route
                path="pages/:slug/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title> صفحات</title>
                    </Helmet>
                    <Crawl.Pages />
                  </>
                }
              />
              <Route path="linkgraph">
                <Route
                  path="graph/:slug/:domain_slug/:domain"
                  element={
                    <>
                      <Helmet>
                        <title> گراف پیوند </title>
                      </Helmet>
                      <Crawl.Graph />
                    </>
                  }
                />
                <Route
                  path="tree-basic/:slug/:domain_slug/:domain"
                  element={
                    <>
                      <Helmet>
                        <title> درخت پایه </title>
                      </Helmet>
                      <Crawl.TreeBasic />
                    </>
                  }
                />
                <Route
                  path="tree-radial/:slug/:domain_slug/:domain"
                  element={
                    <>
                      <Helmet>
                        <title> درخت مرکزی </title>
                      </Helmet>
                      <Crawl.TreeRadial />
                    </>
                  }
                />
                <Route
                  path=":slug/:domain_slug/:domain"
                  element={
                    <>
                      <Helmet>
                        <title> گراف پیوند </title>
                      </Helmet>
                      <Crawl.Linkgraph />
                    </>
                  }
                />
              </Route>
              <Route
                path="internal-link/:slug/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title> پیوند داخلی خزش</title>
                    </Helmet>
                    <Crawl.InternalLink />
                  </>
                }
              />
              <Route
                path="external-link/:slug/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title> پیوند خارجی </title>
                    </Helmet>
                    <Crawl.ExternalLink />
                  </>
                }
              />
              <Route
                path="check-list/:slug/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>فهرست بازبینی خزش</title>
                    </Helmet>
                    {/* {setBreadcrumbData([{ text: 'فهرست بازبینی', href: '#' }])} */}
                    <Crawl.CheckList />
                  </>
                }
              />
              <Route
                path="*"
                element={
                  <Navigate to={`/crawl/${domain_slug}/${domain}`} replace />
                }
              />
            </Route>
            {/* DOMAINS ROUTER */}
            <Route
              path="/domains"
              element={
                <>
                  <Helmet>
                    <title>دامنه ها</title>
                  </Helmet>
                  <Domain />
                </>
              }
            >
              <Route
                path=""
                element={
                  <>
                    <Helmet>
                      <title>نمای کلی</title>
                    </Helmet>
                  </>
                }
              />
            </Route>

            <Route path="/keyword-tracker" element={<KeywordTracker.Layout />}>
              <Route
                path="overview/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>نمای کلی</title>
                    </Helmet>
                    <KeywordTracker.Overview />
                  </>
                }
              />
              <Route
                path="keywords/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>مدیریت کلمات کلیدی جدید</title>
                    </Helmet>
                    <React.Suspense fallback={<></>}>
                      <KeywordTracker.Manage />
                    </React.Suspense>
                  </>
                }
              />
              <Route
                path="rank-historical/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>آرایش رتبه جدید</title>
                    </Helmet>
                    <React.Suspense fallback={<></>}>
                      <KeywordTracker.RankHistorical />
                    </React.Suspense>
                  </>
                }
              />
              <Route
                path="groups/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>دسته ها</title>
                    </Helmet>
                    <React.Suspense fallback={<></>}>
                      <KeywordTracker.Groups />
                    </React.Suspense>
                  </>
                }
              />
              <Route
                path="tags/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>برچسب ها</title>
                    </Helmet>
                    <React.Suspense fallback={<></>}>
                      <KeywordTracker.Tags />
                    </React.Suspense>
                  </>
                }
              />
              <Route
                path="landing-urls/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>صفحه هدف</title>
                    </Helmet>
                    <React.Suspense fallback={<></>}>
                      <KeywordTracker.LandingUrls />
                    </React.Suspense>
                  </>
                }
              />
              <Route
                path="map/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>نقشه کلمات</title>
                    </Helmet>
                    <React.Suspense fallback={<></>}>
                      <KeywordTracker.Map />
                    </React.Suspense>
                  </>
                }
              />

              <Route
                path="competitors/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>رقیب </title>
                    </Helmet>
                    <React.Suspense fallback={<></>}>
                      <KeywordTracker.Competitors />
                    </React.Suspense>
                  </>
                }
              />
            </Route>

            <Route path="/tracker-ai" element={<TrackerAi.Layout />}>
              <Route index element={<RedirectTrackerAi section="overview" />} />
              <Route path="onboarding" element={<RedirectTrackerAi section="onboarding" />} />
              <Route
                path="onboarding/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>ردیاب AI — راه‌اندازی</title>
                    </Helmet>
                    <TrackerAi.Onboarding />
                  </>
                }
              />
              <Route path="overview" element={<RedirectTrackerAi section="overview" />} />
              <Route
                path="overview/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>ردیاب AI — داشبورد</title>
                    </Helmet>
                    <TrackerAi.Dashboard />
                  </>
                }
              />
              <Route path="prompts" element={<RedirectTrackerAi section="prompts" />} />
              <Route
                path="prompts/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>ردیاب AI — پرامپت‌ها</title>
                    </Helmet>
                    <TrackerAi.Prompts />
                  </>
                }
              />
              <Route path="topics" element={<RedirectTrackerAi section="topics" />} />
              <Route
                path="topics/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>ردیاب AI — تاپیک‌ها</title>
                    </Helmet>
                    <TrackerAi.Topics />
                  </>
                }
              />
              <Route path="executions" element={<RedirectTrackerAi section="executions" />} />
              <Route
                path="executions/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>ردیاب AI — اجراها</title>
                    </Helmet>
                    <TrackerAi.Executions />
                  </>
                }
              />
              <Route path="visibility" element={<RedirectTrackerAi section="visibility" />} />
              <Route
                path="visibility/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>ردیاب AI — دیده‌شدن</title>
                    </Helmet>
                    <TrackerAi.Visibility />
                  </>
                }
              />
              <Route path="competitors" element={<RedirectTrackerAi section="competitors" />} />
              <Route
                path="competitors/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>ردیاب AI — رقبا</title>
                    </Helmet>
                    <TrackerAi.Competitors />
                  </>
                }
              />
              <Route path="sources" element={<RedirectTrackerAi section="sources" />} />
              <Route
                path="sources/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>ردیاب AI — منابع</title>
                    </Helmet>
                    <TrackerAi.Sources />
                  </>
                }
              />
              <Route path="settings" element={<RedirectTrackerAi section="settings" />} />
              <Route
                path="settings/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>ردیاب AI — تنظیمات</title>
                    </Helmet>
                    <TrackerAi.Settings />
                  </>
                }
              />
            </Route>

            <Route
              path="/mcp/connect"
              element={
                <>
                  <Helmet>
                    <title>دستیار AI — اتصال MCP</title>
                  </Helmet>
                  <Mcp.Connect />
                </>
              }
            />
            <Route path="/chat" element={<Mcp.Layout />}>
              <Route
                index
                element={
                  <>
                    <Helmet>
                      <title>دستیار AI</title>
                    </Helmet>
                    <Mcp.Chat />
                  </>
                }
              />
              <Route
                path="history"
                element={
                  <>
                    <Helmet>
                      <title>دستیار AI — سابقه چت</title>
                    </Helmet>
                    <Mcp.History />
                  </>
                }
              />
              <Route
                path="skills"
                element={
                  <>
                    <Helmet>
                      <title>دستیار AI — مهارت‌ها</title>
                    </Helmet>
                    <Mcp.Skills />
                  </>
                }
              />
              <Route
                path="faq/:key"
                element={
                  <>
                    <Helmet>
                      <title>دستیار AI — سوالات متداول</title>
                    </Helmet>
                    <Mcp.FaqSteps />
                  </>
                }
              />
              <Route
                path="prompts"
                element={
                  <>
                    <Helmet>
                      <title>دستیار AI — قالب‌های پرامپت</title>
                    </Helmet>
                    <Mcp.Prompts />
                  </>
                }
              />
              <Route
                path="settings"
                element={
                  <>
                    <Helmet>
                      <title>دستیار AI — تنظیمات</title>
                    </Helmet>
                    <Mcp.Settings />
                  </>
                }
              />
              <Route
                path="*"
                element={
                  <>
                    <Helmet>
                      <title>دستیار AI</title>
                    </Helmet>
                    <Mcp.Chat />
                  </>
                }
              />
            </Route>
            <Route path="/mcp/*" element={<RedirectMcpToChat />} />
            <Route path="/mcp" element={<RedirectMcpToChat />} />

            {/* KEYWORD RESEARCH ROUTER */}
            <Route
              path="/keyword-research"
              element={<KeywordResearch.Layout />}
            >
              <Route
                path="related/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>کلمات مرتبط</title>
                    </Helmet>
                    <KeywordResearch.Related />
                  </>
                }
              />
              <Route path="massive">
                <Route
                  path=":domain_slug/:domain"
                  element={
                    <>
                      <Helmet>
                        <title>کلمات انبوه</title>
                      </Helmet>
                      <KeywordResearch.Massive />
                    </>
                  }
                />
                <Route
                  path=":domain_slug/:domain/:id"
                  element={
                    <>
                      <Helmet>
                        <title>کلمات انبوه</title>
                      </Helmet>
                      <KeywordResearch.MassiveDetails />
                    </>
                  }
                />
              </Route>
              <Route path="planner">
                <Route
                  path=":domain_slug/:domain"
                  element={
                    <>
                      <Helmet>
                        <title>کیورد پلنر</title>
                      </Helmet>
                      <KeywordResearch.Planner />
                    </>
                  }
                />
                {/*
                  Use :slug/* so keywords with spaces (%20) never break route matching.
                  Loc/lang/keyword remain in the URL for display but are not required params.
                */}
                <Route
                  path=":domain_slug/:domain/:slug/*"
                  element={
                    <>
                      <Helmet>
                        <title>کیورد پلنر</title>
                      </Helmet>
                      <KeywordResearch.PlannerDetails />
                    </>
                  }
                />
              </Route>
              <Route
                path="keyword-gap/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>کیورد گپ</title>
                    </Helmet>
                    <KeywordResearch.Gap />
                  </>
                }
              />
              <Route path="clustering">
                <Route
                  path=":domain_slug/:domain"
                  element={
                    <>
                      <Helmet>
                        <title>خوشه بندی</title>
                      </Helmet>
                      <KeywordResearch.Clustering />
                    </>
                  }
                />
                <Route
                  path=":domain_slug/:domain/:id"
                  element={
                    <>
                      <Helmet>
                        <title>خوشه بندی</title>
                      </Helmet>
                      <KeywordResearch.ClusteringDetails />
                    </>
                  }
                />
              </Route>
              <Route
                path="competitors/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title> کلمات رقیب</title>
                    </Helmet>
                    <KeywordResearch.Competitors />
                  </>
                }
              />
              <Route
                path="search-volume/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title> میزان جستجو</title>
                    </Helmet>
                    <KeywordResearch.SearchVolume />
                  </>
                }
              />
              <Route path="keyword-gsc">
                <Route
                  path=":domain_slug/:domain"
                  element={
                    <>
                      <Helmet>
                        <title>کلمات GSC</title>
                      </Helmet>
                      <KeywordResearch.Gsc />
                    </>
                  }
                />
                <Route
                  path=":domain_slug/:domain/:slug"
                  element={
                    <>
                      <Helmet>
                        <title>کلمات GSC</title>
                      </Helmet>
                      <KeywordResearch.GscDetails />
                    </>
                  }
                />
              </Route>
              <Route
                path="combination/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title> ترکیب کلمات</title>
                    </Helmet>
                    <KeywordResearch.Combination />
                  </>
                }
              />
              <Route path="ai-keywords">
                <Route
                  path="history/:domain_slug/:domain"
                  element={
                    <>
                      <Helmet>
                        <title>کلمات AI</title>
                      </Helmet>
                      <KeywordResearch.AiKeywords />
                    </>
                  }
                />
                <Route
                  path="details/:task_id/:domain_slug/:domain"
                  element={
                    <>
                      <Helmet>
                        <title>جزئیات کلمات AI</title>
                      </Helmet>
                      <KeywordResearch.AiKeywordsDetails />
                    </>
                  }
                />
              </Route>
            </Route>
            {/* SERP ROUTER */}
            <Route path="/serp" element={<Serp.Layput />}>
              <Route
                path="history/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>تاریخچه Serp</title>
                    </Helmet>
                    <Serp.History />
                  </>
                }
              />
              <Route
                path="overview/:domain_slug/:domain/:slug/:loc/:lang/:keyword"
                element={
                  <>
                    <Helmet>
                      <title>نمای کلی</title>
                    </Helmet>
                    <Serp.Overview />
                  </>
                }
              />
              <Route
                path="results/:domain_slug/:domain/:slug/:loc/:lang/:keyword"
                element={
                  <>
                    <Helmet>
                      <title>بررسی نتایج</title>
                    </Helmet>
                    <Serp.Results />
                  </>
                }
              />
              <Route
                path="content-brief/:domain_slug/:domain/:slug/:loc/:lang/:keyword"
                element={
                  <>
                    <Helmet>
                      <title>بریف محتوا</title>
                    </Helmet>
                    <Serp.ContentBrief />
                  </>
                }
              />
              <Route
                path="*"
                element={
                  <Navigate
                    to={`/serp/history/${domain_slug}/${domain}`}
                    replace
                  />
                }
              />
            </Route>

            {/* CONTENT TOOLS ROUTER */}
            <Route path="/content-tools" element={<ContentTools.Layout />}>
              <Route
                path="ai-analysis/history/:domain_slug/:domain"
                element={
                  <>
                    <Helmet>
                      <title>تاریخچه تحلیل AI</title>
                    </Helmet>
                    <ContentTools.Ai />
                  </>
                }
              />
              <Route
                path="ai-analysis/overview/:domain_slug/:domain/:slug"
                element={
                  <>
                    <Helmet>
                      <title>نمای کلی تحلیل AI</title>
                    </Helmet>
                    <ContentTools.AiDetails />
                  </>
                }
              />
              <Route
                path="ai-analysis/seo/:domain_slug/:domain/:slug"
                element={
                  <>
                    <Helmet>
                      <title>تحلیل سئو</title>
                    </Helmet>
                    <ContentTools.AiDetails />
                  </>
                }
              />
              <Route
                path="ai-analysis/detector/:domain_slug/:domain/:slug"
                element={
                  <>
                    <Helmet>
                      <title>تشخیص AI</title>
                    </Helmet>
                    <ContentTools.AiDetails />
                  </>
                }
              />
              <Route
                path="ai-analysis/eeat/:domain_slug/:domain/:slug"
                element={
                  <>
                    <Helmet>
                      <title>تحلیل EEAT</title>
                    </Helmet>
                    <ContentTools.AiDetails />
                  </>
                }
              />
              <Route
                path="ai-analysis/geo/:domain_slug/:domain/:slug"
                element={
                  <>
                    <Helmet>
                      <title>تحلیل GEO</title>
                    </Helmet>
                    <ContentTools.AiDetails />
                  </>
                }
              />
              <Route
                path="ai-analysis/details/:id/:domain_slug/:domain"
                element={<RedirectLegacyAiDetails />}
              />
              <Route
                path="*"
                element={
                  <Navigate
                    to={`/content-tools/ai-analysis/history/${domain_slug}/${domain}`}
                    replace
                  />
                }
              />
            </Route>
            {/* ORDERS */}
            <Route
              path="/orders"
              element={
                <>
                  <Helmet>
                    <title>سفارشات</title>
                  </Helmet>
                  <Purchase.OrdersPage />
                </>
              }
            />
            <Route
              path="/wallet/transactions"
              element={
                <>
                  <Helmet>
                    <title>تراکنش های کیف پول</title>
                  </Helmet>
                  <Wallet.Transactions />
                </>
              }
            />
            <Route
              path="/wallet/payment"
              element={
                <>
                  <Helmet>
                    <title>نتیجه پرداخت کیف پول</title>
                  </Helmet>
                  <Wallet.Payment />
                </>
              }
            />
            {/* PROGROGATE OR UPGRADE ROUTER */}
            <Route path="/prorogate-or-upgrade" element={<Purchase.Layout />}>
              <Route
                path=""
                element={
                  <>
                    <Helmet>
                      <title>تغییر یا تمدید طرح</title>
                    </Helmet>
                    <Purchase.Overview />
                  </>
                }
              />
              <Route
                path="payment"
                element={
                  <>
                    <Helmet>
                      <title>پرداخت</title>
                    </Helmet>
                    <Purchase.Payment />
                  </>
                }
              />

              <Route
                path="order"
                element={
                  <>
                    <Helmet>
                      <title>تایید سفارش</title>
                    </Helmet>
                    <Purchase.Order />
                  </>
                }
              />
            </Route>
            {/* SUPPORT ROUTER */}
            <Route path="/support" element={<Support.Layout />}>
              <Route
                path="mentoring"
                element={
                  <>
                    <Helmet>
                      <title>منتورینگ</title>
                    </Helmet>
                    <Support.Mentoring />
                  </>
                }
              />
            </Route>
            {/* SETTINGS ROUTER */}
            <Route path="/settings" element={<Settings.Layout />}>
              <Route
                path="domain_access"
                element={
                  <>
                    <Helmet>
                      <title>تنظیمات دسترسی</title>
                    </Helmet>
                    <Settings.DomainAccess />
                  </>
                }
              />
              <Route
                path="ai"
                element={
                  <>
                    <Helmet>
                      <title>تنظیمات AI</title>
                    </Helmet>
                    <Settings.AI />
                  </>
                }
              />
              <Route
                path="api-key"
                element={
                  <>
                    <Helmet>
                      <title>تنظیمات API Key</title>
                    </Helmet>
                    <Settings.ApiKey />
                  </>
                }
              />
              <Route
                path="mcp"
                element={
                  <>
                    <Helmet>
                      <title>تنظیمات MCP</title>
                    </Helmet>
                    <Settings.MCP />
                  </>
                }
              />
              <Route
                path="appearance"
                element={
                  <>
                    <Helmet>
                      <title>تنظیمات ظاهری</title>
                    </Helmet>
                    <Settings.Appearance />
                  </>
                }
              />
            </Route>
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/errors/404" replace />} />
      </Routes>
    </React.Suspense>
  );
};

export default FalconRoutes;
